import React from "react";

export const Blog = ({ fontSize = "1.8rem" }) => {
  return (
    <div
      id="blog"
      className="blog-section"
      style={{ "--post-font-size": fontSize }}
    >
      <div className="blog-container">
        {/* --- Blog2 --- */}
        <article className="post">
          <h1 className="post-title">
            Primer taller de Merida   {/* --- titulo --- */}
          </h1>
          <div className="post-meta">
            <span className="meta-item">
              <img src="/img/autor.png" alt="Autor" className="icon" />
              By{" "}
              <a
                href="https://labdemoss.c3.unam.mx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Lab-DEMOSS  {/* --- autor --- */}
              </a>
            </span>
            <span>•</span>
            <span className="meta-item">
              <img
                src="/img/calendario.png"
                alt="Fecha"
                className="icon"
              />
              Junio 26, 2025
            </span>
          </div>
          <div className="post-image">
            <img
              src="/img/blog/blog1titulo.jpeg"
              alt="UNAM recibe premio GAR 2024"
            />
          </div>
          <div className="post-content">
            <p>
              El proyecto “Tejedores comunitarios de IA y soluciones basadas en la naturaleza” es un proyecto que integra la inteligencia artificial, la participación social y la sostenibilidad para transformar la movilidad urbana. La propuesta se enfoca en el estudio de caso de la ciudad de Mérida, Yucatán, donde se busca mejorar el acceso a las paradas de autobús y optimizar las rutas de tránsito a través del análisis de imágenes satelitales y algoritmos de IA.
            </p>
            <p>
              La idea es reunir a usuarios del transporte público, asociaciones civiles, autoridades locales y especialistas en inteligencia artificial para diseñar estrategias que favorezcan un transporte más seguro, eficiente y amigable con el entorno urbano. Además, el proyecto pretende desarrollar una plataforma digital que permita explorar y sugerir rutas óptimas no solo para Mérida, sino también para otras ciudades, promoviendo la integración de la naturaleza en el desarrollo urbano y fomentando espacios más verdes y equitativos.
            </p>
          </div>
        </article>

        <hr className="post-separator" />

        {/* --- Blog1 --- */}
        <article className="post">
          <h1 className="post-title">
            Tejedores Comunitarios
          </h1>
          <div className="post-meta">
            <span className="meta-item">
              <img src="/img/autor.png" alt="Autor" className="icon" />
              By{" "}
              <a
                href="https://labdemoss.c3.unam.mx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Lab-DEMOSS
              </a>
            </span>
            <span>•</span>
            <span className="meta-item">
              <img
                src="/img/calendario.png"
                alt="Fecha"
                className="icon"
              />
              Junio 26, 2025
            </span>
          </div>
          <div className="post-image">
            <img
              src="/img/blog/blog1titulo.jpeg"
              alt="UNAM recibe premio GAR 2024"
            />
          </div>
          <div className="post-content">
            <p>
              El proyecto “Tejedores comunitarios de IA y soluciones basadas en la naturaleza” es un proyecto que integra la inteligencia artificial, la participación social y la sostenibilidad para transformar la movilidad urbana. La propuesta se enfoca en el estudio de caso de la ciudad de Mérida, Yucatán, donde se busca mejorar el acceso a las paradas de autobús y optimizar las rutas de tránsito a través del análisis de imágenes satelitales y algoritmos de IA.
            </p>
            <p>
              La idea es reunir a usuarios del transporte público, asociaciones civiles, autoridades locales y especialistas en inteligencia artificial para diseñar estrategias que favorezcan un transporte más seguro, eficiente y amigable con el entorno urbano. Además, el proyecto pretende desarrollar una plataforma digital que permita explorar y sugerir rutas óptimas no solo para Mérida, sino también para otras ciudades, promoviendo la integración de la naturaleza en el desarrollo urbano y fomentando espacios más verdes y equitativos.
            </p>
          </div>
        </article>

        <hr className="post-separator" />

      </div>
      <style jsx>{`
        .blog-section {
          --post-font-size: 1rem;
          padding: 60px 0;
          background: #fff;
        }
        .blog-container {
          width: 70%;
          margin: 0 auto;
        }
        .post {
          margin-bottom: 40px;
        }
        .post-title {
          font-size: 5rem;
          font-weight: bold;
          margin-bottom: 0.5em;
          color: #222;
          text-align: center;
        }
        .post-meta {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.5em;
          font-size: 1.5rem;
          color: #666;
          margin-bottom: 1.5em;
        }
        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.3em;
        }
        .icon {
          width: 1.2em;
          height: 1.2em;
        }
        .post-meta a {
          color: #d00;
          text-decoration: none;
        }
        .post-meta a:hover {
          text-decoration: underline;
        }
        .post-image img {
          width: 100%;
          height: auto;
          margin-bottom: 2em;
          object-fit: cover;
        }
        .post-content {
          width: 55%;
          margin: 0 auto;
          line-height: 1.6;
          color: #333;
          text-align: justify;
        }
        .post-content p {
          margin-bottom: 1.5em;
          font-size: var(--post-font-size);
        }
        .post-content a {
          color: #d00;
          text-decoration: none;
        }
        .post-content a:hover {
          text-decoration: underline;
        }
        .inline-image {
          text-align: center;
          margin: 1.5em 0;
        }
        .inline-image img {
          display: block;
          margin: 0 auto;
          width: 50%;
          height: auto;
          object-fit: cover;
        }
        .image-gallery {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1em;
          margin: 2em 0;
        }
        .image-gallery img {
          width: 100%;
          height: 100%;
          aspect-ratio: 1 / 1;
          object-fit: cover;
        }
        .post-separator {
          border: none;
          border-top: 1px solid #ddd;
          width: 100%;
          margin: 3em auto;
        }
      `}</style>
    </div>
  );
};
